package one.healthium.log_weight.ui.internal

import androidx.compose.runtime.Immutable
import kotlin.time.Instant

@Deprecated("use WeightHistoryUiModel")
@Immutable
data class WeightUiModel(
    val currentWeight: Float,
    val date: Instant?,
)